var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "53px",
    height: "47px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    strokeWidth: "2px",
    stroke: "rgb(206, 50, 104)",
    fillOpacity: 0.4,
    fill: "rgb(206, 50, 104)",
    d: "M38.479,3.845 C43.561,3.728 47.043,8.144 48.377,12.368 C49.884,17.130 48.634,22.085 46.565,26.683 C44.432,31.418 41.549,35.837 39.488,40.599 C39.143,41.399 38.831,42.211 38.543,43.027 C38.537,43.034 38.529,43.041 38.520,43.045 C38.513,43.098 38.482,43.146 38.439,43.186 C38.428,43.215 38.418,43.243 38.397,43.269 C38.384,43.293 38.376,43.320 38.359,43.339 C38.360,43.427 38.321,43.513 38.218,43.564 C38.185,43.581 38.148,43.592 38.117,43.592 C38.109,43.593 38.106,43.599 38.100,43.608 C38.033,43.637 37.965,43.643 37.911,43.624 C37.882,43.627 37.856,43.629 37.829,43.621 C37.818,43.627 37.807,43.631 37.793,43.640 C34.366,43.093 30.937,42.552 27.545,41.840 C22.358,40.746 17.135,39.296 12.593,36.702 C8.467,34.344 5.155,30.845 4.237,26.152 C3.323,21.495 4.213,17.255 8.166,13.207 C10.237,9.450 18.410,7.755 26.105,15.462 C29.343,18.497 25.336,4.649 38.479,3.845 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.4dda760501d8efe0ef7f99c4e7f36c48.svg";
export { ForwardRef as ReactComponent };